import { render, staticRenderFns } from "./agentType.vue?vue&type=template&id=2fb9e4d8"
import script from "./agentType.vue?vue&type=script&lang=js"
export * from "./agentType.vue?vue&type=script&lang=js"
import style0 from "./agentType.vue?vue&type=style&index=0&id=2fb9e4d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports